<template>
<section class="content">
  <div class="box box-info">
    <commisionSetup ref="commisionSetup" />
    <commisionList @delete-message="deleteCommision" @edit-commision="editCommision" ref="deleteData" />
  </div>
</section>
</template>
<script>
import commisionSetup from './commisionSetup.vue'
import commisionList from './commisionList.vue'
// import accountgroupdialog from '../accountDialog/AccountGroupDialog.vue'
export default {
  name: 'commision',
  data() {
    return {}
  },
  methods: {
    editCommision(data) {
      this.$refs.commisionSetup.openCommisionSetup(data)
    },
    deleteCommision(value) {
      this.$toast.add({
        severity: value.messageType,
        summary: '',
        detail: value.message,
        life: 10000
      })
    }
  },
  components: {
    commisionSetup,
    commisionList
    // accountgroupdialog
  }
}
</script>



// WEBPACK FOOTER //
// commision.vue?0b2c617b